<script>
import Autocomplete from "@/components/_Shared/Autocomplete";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    Autocomplete
  },

  data() {
    return {
      results: [],
      preloader: false
    };
  },

  computed: {
    ...mapState("newOrder", ["user"])
  },

  methods: {
    ...mapActions("newOrder", ["setUser"]),
    ...mapActions("clients", ["searchByName"]),

    selectUser(user) {
      this.setUser(user);
      this.results = [];
    },

    async search(query) {
      this.preloader = true;

      try {
        this.results = await this.searchByName(query);
      } catch (e) {}

      this.preloader = false;
    }
  }
};
</script>

<template>
  <div class="section">
    <div class="section-title">
      SELECIONE O USUÁRIO
      <hr />
    </div>

    <autocomplete
      label="digite o email do usuário"
      :selected="user"
      :results="results"
      :preloader="preloader"
      :labels="['first_name', 'last_name', 'email']"
      :separators="[' ', ' (', ')']"
      @search="search"
      @select="selectUser"
    />
  </div>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Steps/SelectUser.vue